import { TimeAgo } from "components/TimeAgo/TimeAgo";
import Tooltip from "components/Tooltip/Tooltip";
import { getLocalTimezoneDate } from "config/ts-utils";

export const TimeAgoWithDateTimeFormatter = ({ datetime }: { datetime: string }) => {
    const localTimezoneDate = getLocalTimezoneDate(datetime);
    return (
        <Tooltip
            overlay={localTimezoneDate}
            overlayStyle={{ zIndex: 3000 }}
            overlayClassName="light overlapText"
            placement="bottomLeft"
            align={{ points: ["cc", "cc"], offset: [0, 0] }}
        >
            <TimeAgo datetime={datetime} hideTooltip={true} />
        </Tooltip>
    );
};
